import Vue from 'vue';
import Router from 'vue-router';
import Reg1 from './pages/Reg1.vue';
import Reg2 from './pages/Reg2.vue';
import Reg3 from './pages/Reg3.vue';
import LoanOffers from './pages/LoanOffers.vue';
import DirectDebitOptIn from './pages/DirectDebitOptIn.vue';
import LoanApplications from './pages/LoanApplications.vue';
import LoanStatus from './pages/LoanStatus.vue';
import RegEbs from './pages/RegEbs.vue';
import Preapprovals from './pages/Preapprovals.vue';
import {
  beforeEnterReg1, beforeEnterReg2, beforeEnterReg3, beforeEach, afterEach,
  beforeEnterPreReg2Ebs, beforeEnterPreLoanOfferEbs,
  beforeEnterLoanOffers, beforeEnterAccountHome,
} from './lib/routerHelpers';

Vue.use(Router);

const router = new Router({
  mode:   'history',
  base:   process.env.BASE_URL,
  routes: [
    {
      path:        '/v/registrar',
      name:        'vue-registrar',
      component:   Reg1,
      beforeEnter: async (to, from, next) => beforeEnterReg1(to, from, next),
    },
    {
      path:        '/v/pessoal/ebs',
      name:        'pre-reg2-ebs',
      component:   RegEbs,
      props:       { regStep: 'preReg2' },
      beforeEnter: async (to, from, next) => beforeEnterPreReg2Ebs(to, from, next),
    },
    {
      path:        '/v/pessoal',
      name:        'vue-pessoal',
      component:   Reg2,
      beforeEnter: async (to, from, next) => beforeEnterReg2(to, from, next),
    },
    {
      path:        '/v/financeiro',
      name:        'vue-financeiro',
      component:   Reg3,
      beforeEnter: async (to, from, next) => beforeEnterReg3(to, from, next),
    },
    {
      path:        '/v/financeiro/ebs',
      name:        'pre-loan-offer-ebs',
      component:   RegEbs,
      props:       { regStep: 'preLoanOffer' },
      beforeEnter: async (to, from, next) => beforeEnterPreLoanOfferEbs(to, from, next),
    },
    {
      path:        '/loan_applications/loan_offers',
      name:        'vue-loan-offers',
      component:   LoanOffers,
      beforeEnter: async (to, from, next) => beforeEnterLoanOffers(to, from, next),
    },
    {
      path:        '/loan_applications',
      name:        'loan-applications',
      component:   LoanApplications,
      beforeEnter: async (to, from, next) => beforeEnterAccountHome(to, from, next),
    },
    {
      path:        '/loan_application/opt_in',
      name:        'loan-application-opt-in',
      component:   DirectDebitOptIn,
      beforeEnter: async (to, from, next) => beforeEnterAccountHome(to, from, next),
    },
    {
      path:        '/loan-status',
      name:        'loan-status',
      component:   LoanStatus,
      beforeEnter: async (to, from, next) => beforeEnterAccountHome(to, from, next),
    },
    {
      path:      '/preapproved/:id',
      name:      'preapprovals',
      component: Preapprovals,
    },
  ],
});

router.beforeEach(async (to, from, next) => beforeEach(to, from, next));

router.afterEach((to) => afterEach(to));

export default router;
